<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh;">
    <v-layout row wrap>
      <v-toolbar>
        <v-toolbar-title>Actualizaciones skolable</v-toolbar-title>
      </v-toolbar>
        <v-container fluid elevation-2 style="max-height: 85vh;" :class="!$vuetify.breakpoint.xsOnly ? '' : 'scrollDesign'">
            <v-layout  wrap justify-space-around fill-height align-center>
                <v-flex xs12 sm4 md4 lg4 @click="adminUpSave()">
                    <v-badge
                        style="float: right; display: flex;"
                        overlap
                        dot
                        color="#ff0000"
                        v-show="adminUp()"
                    >
                        <template v-slot:badge>
                            <span>1</span>
                        </template>
                    </v-badge>
                    <div :class="!$vuetify.breakpoint.xsOnly ? $vuetify.breakpoint.mdOnly || $vuetify.breakpoint.smOnly ? 'zoomB expandableContainer' : $vuetify.breakpoint.xlOnly ? 'zoomC expandableContainer' : 'zoom expandableContainer' : 'expandableContainer zoomA'">
                        <a style="color: #f5f5f5; text-decoration:none" href="https://sites.google.com/kiritek.com/centrodeayudaskolable/actualizaciones/administrador-web" target="_blank">
                            <v-img small :class="!$vuetify.breakpoint.xsOnly ? $vuetify.breakpoint.mdOnly ? 'imgStyleB' : $vuetify.breakpoint.xlOnly ? 'imgStyleC' :  $vuetify.breakpoint.smOnly ? 'imgStyleD' : 'imgStyle' : 'imgStyleA'" :src="require('@/assets/updateI/administradorWeb.png')" aspect-ratio="2.75">
                                <v-container>
                                    <v-layout>
                                        <v-flex flexbox :style="!$vuetify.breakpoint.xsOnly ? ( $vuetify.breakpoint.smOnly ? 'margin-top: 40px; background-color: #ffffff94;' :'margin-top: -20px;  background-color: #ffffff94;' ) : 'margin-top: 68px; background-color: #ffffff94;'">
                                            <span class="letter black--text" style="font-weight: bold">Administrador Web</span>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-img>
                        </a>
                    </div>
                </v-flex>
                <v-flex xs12 sm4 md4 lg4 shrink @click="staffUpSave()">
                    <v-badge
                        style="float: right; display: flex;"
                        overlap
                        color="#ff0000"
                        v-show="staffUp()"
                    >
                        <template v-slot:badge>
                            <span>1</span>
                        </template>
                    </v-badge>
                    <div :class="!$vuetify.breakpoint.xsOnly ? $vuetify.breakpoint.mdOnly || $vuetify.breakpoint.smOnly ? 'zoomB expandableContainer' : $vuetify.breakpoint.xlOnly ? 'zoomC expandableContainer' : 'zoom expandableContainer' : 'expandableContainer zoomA'">
                        <a style="color: #f5f5f5;" href="https://sites.google.com/kiritek.com/centrodeayudaskolable/actualizaciones/app-tutores" target="_blank">
                            <v-img small :class="!$vuetify.breakpoint.xsOnly ? $vuetify.breakpoint.mdOnly ? 'imgStyleB' : $vuetify.breakpoint.xlOnly ? 'imgStyleC' :  $vuetify.breakpoint.smOnly ? 'imgStyleD' : 'imgStyle' : 'imgStyleA'" :src="require('@/assets/updateI/AppTutores.png')" aspect-ratio="2.75">
                                <v-container>
                                    <v-layout>
                                        <v-flex flexbox :style="!$vuetify.breakpoint.xsOnly ?  $vuetify.breakpoint.smOnly ? 'margin-top: 40px; background-color: #ffffff94;' :'margin-top: -20px; background-color: #ffffff94;' : 'margin-top: 68px; background-color: #ffffff94;'">
                                            <span class="letter black--text" style="font-weight: bold">App de tutores iOS/Android</span>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-img>
                        </a>
                    </div>
                </v-flex>
                <v-flex xs12 sm4 md4 lg4 @click="tutorsUpSave()">
                    <v-badge
                        style="float: right; display: flex;"
                        overlap
                        color="#ff0000"
                        v-show="tutorsUp()"
                    >
                        <template v-slot:badge>
                            <span>1</span>
                        </template>
                    </v-badge>
                    <div :class="!$vuetify.breakpoint.xsOnly ? $vuetify.breakpoint.mdOnly || $vuetify.breakpoint.smOnly ?'zoomB expandableContainer' : $vuetify.breakpoint.xlOnly ? 'zoomC expandableContainer' : 'zoom expandableContainer' : 'expandableContainer zoomA'">
                        <a style="color: #f5f5f5;" href="https://sites.google.com/kiritek.com/centrodeayudaskolable/actualizaciones/app-staff-y-klipy" target="_blank">
                            <v-img small :class="!$vuetify.breakpoint.xsOnly ? $vuetify.breakpoint.mdOnly ? 'imgStyleB' : $vuetify.breakpoint.xlOnly ? 'imgStyleC' :  $vuetify.breakpoint.smOnly ? 'imgStyleD' : 'imgStyle' : 'imgStyleA'" :src="require('@/assets/updateI/AppStaff.png')" aspect-ratio="2.75">
                                <v-container>
                                    <v-layout>
                                        <v-flex flexbox :style="!$vuetify.breakpoint.xsOnly ?  $vuetify.breakpoint.smOnly ? 'margin-top: 40px; background-color: #ffffff94;' :'margin-top: -20px; background-color: #ffffff94;' : 'margin-top: 68px; background-color: #ffffff94;'">
                                            <span class="letter black--text" style="font-weight: bold">App Staff iOS/Android</span>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-img>
                        </a>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data: () => ({
        versionAdmin: "",
        versionStaff: "",
        versionTutorA: "",
        versionTutorIO: "",
        set:"",
    }),
    methods: {
        mapPermits() {
            //Admin
            this.versionAdmin = this.getUser.versions[7].version.split(".");
            for (let a = 0; a < this.versionAdmin.length-1; a++) {
                this.set = this.set+this.versionAdmin[a]+".";
            }
            this.versionAdmin = this.set.substring(0, this.set.length-1);
            this.set="";
            //Staff
            this.versionStaff = this.getUser.versions[0].version.split(".");
            for (let a = 0; a < this.versionStaff.length-1; a++) {
                this.set = this.set+this.versionStaff[a]+".";
            }
            this.versionStaff = this.set.substring(0, this.set.length-1);
            this.set="";
            //TutorAndroid
            this.versionTutorA = this.getUser.versions[1].version.split(".");
            for (let a = 0; a < this.versionTutorA.length-1; a++) {
                this.set = this.set+this.versionTutorA[a]+".";
            }
            this.versionTutorA = this.set.substring(0, this.set.length-1);
            this.set="";
            //TutorIOS
            this.versionTutorIO = this.getUser.versions[2].version.split(".");
            for (let a = 0; a < this.versionTutorIO.length-1; a++) {
                this.set = this.set+this.versionTutorIO[a]+".";
            }
            this.versionTutorIO = this.set.substring(0, this.set.length-1);
            this.set="";


            var usr = this.getUser;
            var wbRol = usr.webRole;
            var catalogs = wbRol.catalogs;
            this.$forceUpdate();
        },
        adminUp(){
            if(localStorage.getItem("ADMIN") == this.versionAdmin){
                return false;
            } else {
                return true;
            }
        },
        adminUpSave(){
            localStorage.setItem("ADMIN",this.versionAdmin);
            this.$forceUpdate();
        },

        staffUp(){
            if(localStorage.getItem("STAFF") == this.versionStaff){
                return false;
            } else {
                return true;
            }
        },
        staffUpSave(){
            localStorage.setItem("STAFF",this.versionStaff);
            this.$forceUpdate();
        },

        tutorsUp(){
            if(localStorage.getItem("TUTORSA") == this.versionTutorA || localStorage.getItem("TUTORSIO") == this.versionTutorIO){
                return false;
            } else {
                return true;
            }
        },
         tutorsUpSave(){
            localStorage.setItem("TUTORSA",this.versionTutorA);
            localStorage.setItem("TUTORSIO", this.versionTutorIO);
            this.$forceUpdate();
        },
    },
    watch: {
        getUser() {
            this.mapPermits();
        }
    },
    mounted() {
        if (this.getUser && this.getUser.id) this.mapPermits();
    },
    computed: {
        ...mapGetters(["getUser"]),
    }
}
</script>
<style>
    .zoom {
        background-color: rgb(245, 245, 245);
        transition: transform .2s; /* Animation */
        margin: 0 auto;
        height: 458px;
    }
    .zoomA {
        background-color: rgb(245, 245, 245);
        transition: transform .2s; /* Animation */
        margin: 0 auto;
        height: 230px;
    }

    .zoomB {
        background-color: rgb(245, 245, 245);
        transition: transform .2s; /* Animation */
        margin: 0 auto;
        height: 280px;
    }

    .zoomC {
        background-color: rgb(245, 245, 245);
        transition: transform .2s; /* Animation */
        margin: 0 auto;
        height: 500px;
    }

    .zoom:hover {
        transform: scale(1.1); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
        background-color: rgb(245, 245, 245);
    }
    .imgStyle{
        height: 341px;
        margin: 50px;
    }
    .imgStyleA{
        height: 200px;
        margin: 73px;
        margin-top: 13px;
    }
    .imgStyleB{
        height: 300px;
    }
    .imgStyleC{
        height: 400px;
        margin: 100px;
        margin-top: 50px;
    }
    .imgStyleD{
        height: 180px;
        margin: 10px;
        margin-top: 40px;
    }
    .letter{
        font-size: 18px;
    }
</style>


